export default "__VITE_ASSET__Bhif835B__"